@if (serverAvailable) {
  <div>
    <app-header></app-header>
    <div class="d-flex">
      <app-main-nav></app-main-nav>
      <div class="main-container">
        <div class="container-fluid content-container">
          <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
    <app-dynamic-modal></app-dynamic-modal>
    <img-modal />
    <app-history/>
    <overlay-spinner/>
  </div>
} @else {
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="text-center">
      <h3>Сервер недоступен</h3>
      <p>Попробуйте обновить страницу позже</p>
    </div>
  </div>
}
